(function () {
  var REVISION = '2025-04-15';

  function subscribe(options) {
    var companyId = options.companyId;
    var listId = options.listId;
    var email = options.email;
    var source = options.source || 'Newsletter';

    if (!companyId || !listId || !email) {
      return Promise.reject(new Error('Configuration Klaviyo manquante'));
    }

    var url =
      'https://a.klaviyo.com/client/subscriptions/?company_id=' +
      encodeURIComponent(companyId);

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: REVISION,
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId,
              },
            },
          },
        },
      }),
    }).then(function (res) {
      if (res.ok || res.status === 202) return res;
      return res
        .text()
        .then(function (raw) {
          var body = null;
          try {
            body = raw ? JSON.parse(raw) : null;
          } catch (e) {
            body = null;
          }
          var detail =
            body &&
            body.errors &&
            body.errors[0] &&
            (body.errors[0].detail || body.errors[0].title);
          if (!detail && res.status) {
            detail = 'Inscription impossible (erreur ' + res.status + ')';
          }
          throw new Error(detail || 'Inscription impossible');
        });
    });
  }

  function bindForm(form) {
    if (form.dataset.klaviyoBound) return;
    form.dataset.klaviyoBound = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var companyId = form.dataset.companyId;
      var listId = form.dataset.listId;
      var source = form.dataset.source || 'Newsletter';
      var emailInput = form.querySelector('input[type="email"]');
      var email = emailInput ? emailInput.value.trim() : '';
      var btn = form.querySelector('button[type="submit"]');
      var fields = form.querySelector('[data-klaviyo-fields]');
      var successEl = form.querySelector('[data-klaviyo-success]');
      var errorEl = form.querySelector('[data-klaviyo-error]');

      if (!email) return;

      if (btn) {
        btn.disabled = true;
        btn.style.opacity = '0.6';
      }
      if (errorEl) errorEl.hidden = true;

      subscribe({ companyId: companyId, listId: listId, email: email, source: source })
        .then(function () {
          if (fields) fields.hidden = true;
          if (successEl) successEl.hidden = false;
          form.dispatchEvent(new CustomEvent('sk-klaviyo:success', { bubbles: true }));
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = err && err.message ? err.message : 'Une erreur est survenue. Réessaie.';
            errorEl.hidden = false;
          }
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.style.opacity = '';
          }
        });
    });
  }

  function initForms() {
    document.querySelectorAll('[data-klaviyo-form]').forEach(bindForm);
  }

  window.skKlaviyoSubscribe = subscribe;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForms);
  } else {
    initForms();
  }

  document.addEventListener('shopify:section:load', initForms);
})();
